import {Component, Input, OnInit} from '@angular/core';

export interface BreadcrumbItem {
  label: string,

  href: string,

  disable?: boolean
}

@Component({
  selector: 'btx-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false
})
export class BreadcrumbComponent implements OnInit {


  //Example
  @Input("items") items: BreadcrumbItem[] = [];

  constructor() {
  }

  ngOnInit(): void {
  }

}
